import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { LoginService } from '../../../services/authentication/login.service';
import { ApiService } from '../../../services/main/api.service';
import { Global } from '../../../services/global';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { Observable, from, of } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-logiclient',
  templateUrl: './logiclient.component.html',
  styleUrls: ['./logiclient.component.css']
})

export class LogiclientComponent implements OnInit {
    @Input() extid: any;

  	id:any;
  	obj:any;
  	isLoading = false;
    base_url:any;

  	constructor(
        public _login: LoginService,
        public _router: Router,
        private route: ActivatedRoute,
        public api: ApiService,
        private _lightbox: Lightbox
      ) {
        this.base_url = Global.url;
    }

  	ngOnInit() {
        this.id = this.route.snapshot.params.id;

        if( (this.id == undefined) || (this.id == '') ){
            if( (this.extid != undefined) && (this.extid != '') ){
                this.id = this.extid;
            }
        }

        this.refresh();
  	}

    ngOnChanges() {
        //console.log('changed parent');
        if( (this.extid != undefined) && (this.extid != '') ){
            this.id = this.extid;
            this.refresh();
        }
    }

  	public getData(id:any){
        var par_url = 'LogisticClient/Info/' + id;

        return this.api.getCallNoAuth(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = data;
                        
                        if(mydata.status ){
                            return of(mydata.data);
                        }
                        else{
                            return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public refresh(){
        //this.id = this.route.snapshot.params.id;
        this.obj = {itemDetail:{}, items:[], images: [], empty:null, receptor: ''};

        if( (this.id != null) && (this.id != undefined) ){
          this.getData(this.id).subscribe(x => {
              
              if( x != false ){
                  if( !Array.isArray(x) ){
                      this.obj.empty = true;
                      return;
                  }

                  this.obj = x[0];
                  this.obj.empty = false;
              
                  let coords = x[0].coordinate.split(';');
                  
                  if( coords.length > 1 ){
                      this.obj.lat = parseFloat(coords[0]);
                      this.obj.lng = parseFloat(coords[1]);
                  }
                  else{
                      this.obj.lat = '';
                      this.obj.lng = '';
                  }

                  var timelines = [];
                  let media_url = this.base_url + 'LogisticClient/media/';

                  x.forEach(t => {
                      let images = [];

                      if( Array.isArray(t.delivery) && (t.delivery.length > 0) ){
                          t.delivery[0].imageIds.forEach(i => {
                              images.push(media_url + i);
                          });

                          images.push(t.delivery[0].sign);

                          timelines.push({
                              images: images,
                              receptor: t.delivery[0]['nameReceptor'] + ' c.i. ' + t.delivery[0]['idReceptor'],
                              timeLine: t.timeLine
                          });
                      }
                      else{
                          timelines.push({
                              images: [],
                              receptor: '',
                              timeLine: t.timeLine
                          });
                      }
                  });

                  this.obj['items'] = timelines;
              }
              else{
                  this.obj.empty = true;
              }
              
          });
        }
    }

    openPreview(img:any): void {
      var album:any;
      album = [
        {src: img}
      ];
        // open lightbox
        this._lightbox.open(album, 0);
    }
}
